<div class="ccl-datefield">
    <div class="ccl-datefield__wrapper">
      <input
        #inputEl
        [type]="showTime ? 'datetime-local' : 'date'"
        class="ccl-datefield__input"
        [value]="getInputValue()"
        [min]="getMinDateString()"
        [max]="getMaxDateString()"
        [disabled]="disabled"
        [attr.aria-required]="required"
        [attr.aria-label]="showTime ? 'Date and time input' : 'Date input'"
        (input)="onDateInput($event)"
        (blur)="onTouched()"
        (click)="onInputClick()"
      />
  
      @if (value) {
        <button
          type="button"
          class="ccl-datefield__clear"
          (click)="clear()"
          aria-label="Clear date"
        >
          ✕
        </button>
      }
    </div>
  
    @if (errorMessage) {
      <div class="ccl-datefield__error">
        {{ errorMessage }}
      </div>
    }
  </div>
  